// extracted by mini-css-extract-plugin
module.exports = {"recruit":"About_recruit__1XGwT","column":"About_column__1Tqm6"};